export const ACCESS_PERMISSION_KEYS = {
  productUpdatesManage: "product_updates.manage",
  assistantUse: "assistant.use",
  assistantQuestionsManage: "assistant.questions.manage",
  geotabRead: "geotab.read",
  geotabManage: "geotab.manage",
  geotabLiveRead: "geotab.live.read",
  geotabCalibrationRead: "geotab.calibration.read",
  geotabCalibrationManage: "geotab.calibration.manage",
  geotabDevicesRead: "geotab.devices.read",
  dispatchGeotabRealRead: "dispatch.geotab_real.read",
  accessRolesWrite: "access.roles.write",
  accessUsersWrite: "access.users.write",
  automationsManage: "automations.manage",
  auditAccessRead: "audit.access.read",
  auditActionsRead: "audit.actions.read",
  billingDraftsManage: "billing.drafts.manage",
  billingRead: "billing.read",
  consolidationHoursManage: "billing.consolidation.hours.manage",
  consolidationGeotabRead: "billing.consolidation.geotab.read",
  consolidationSummaryRead: "billing.consolidation.summary.read",
  consolidationHoursRead: "billing.consolidation.hours.read",
  consolidationRead: "billing.consolidation.read",
  consolidationWrite: "billing.consolidation.write",
  consolidationValidate: "billing.consolidation.validate",
  consolidationReopen: "billing.consolidation.reopen",
  billingSend: "billing.send",
  billingSettingsManage: "billing.settings.manage",
  billingVoid: "billing.void",
  dataManagerImportsManage: "data_manager.imports.manage",
  dataManagerClientCorrespondencesExport: "data_manager.client_correspondences.export",
  dataManagerCompartmentsExport: "data_manager.compartments.export",
  dataManagerDispatchSavesExport: "data_manager.dispatch_saves.export",
  dataManagerEmployeesExport: "data_manager.employees.export",
  dataManagerOrdersExport: "data_manager.orders.export",
  dataManagerProductsExport: "data_manager.products.export",
  dataManagerTrucksExport: "data_manager.trucks.export",
	dataManagerClientCorrespondencesWrite: "data_manager.client_correspondences.write",
  dataManagerEmployeesWrite: "data_manager.employees.write",
  dataManagerOrdersActualTonnageWrite: "data_manager.orders.actual_tonnage.write",
  dataManagerOrdersBulkDelete: "data_manager.orders.bulk_delete",
  dataManagerOrdersClearDelivered: "data_manager.orders.clear_delivered",
  dataManagerOrdersDeleteCompleted: "data_manager.orders.delete_completed",
  dataManagerOrdersDeliveryDriverWrite: "data_manager.orders.delivery_driver.write",
  dataManagerOrdersMarkDelivered: "data_manager.orders.mark_delivered",
  dataManagerOrdersWrite: "data_manager.orders.write",
  dataManagerMeunerieExtraTimeRead: "data_manager.meunerie_extra_time.read",
  dataManagerTruckLoadRatesRead: "data_manager.truck_load_rates.read",
  dataManagerTruckSpeedRead: "data_manager.truck_speed.read",
  dispatchDayClose: "dispatch.day.close",
  dispatchDayInvalidate: "dispatch.day.invalidate",
  dispatchDayPublishPortal: "dispatch.day.publish_portal",
  dispatchDayReopen: "dispatch.day.reopen",
  dispatchDayResetRevalidation: "dispatch.day.reset_revalidation",
  dispatchAssignmentWrite: "dispatch.assignment.write",
  dispatchDeliveryFreeze: "dispatch.delivery.freeze",
  dispatchPullForwardManage: "dispatch.pull_forward.manage",
  dispatchRun: "dispatch.run",
  dispatchRead: "dispatch.read",
  dispatchSnapshotRestore: "dispatch.snapshot.restore",
  dispatchSnapshotWrite: "dispatch.snapshot.write",
  dispatchSourceChangesWrite: "dispatch.source_changes.write",
  driverAccountsManage: "driver.accounts.manage",
  driverPortalAccess: "driver.portal.access",
  importsClientCorrespondencesUpload: "imports.client_correspondences.upload",
  importsCompartmentsUpload: "imports.compartments.upload",
  importsOrdersGuardBypass: "imports.orders.guard_bypass",
  importsOrdersUpload: "imports.orders.upload",
  importsProductsUpload: "imports.products.upload",
  importsEmployeesUpload: "imports.employees.upload",
  importsReplaceAll: "imports.replace_all",
  importsTrucksUpload: "imports.trucks.upload",
  reportsEmailSend: "reports.email.send",
  reportsEmailTemplateWrite: "reports.email.template.write",
  reportsTruckSheetsCompartmentsShow: "reports.truck_sheets.compartments.show",
  reportsTruckPreloadsCompartmentsShow: "reports.truck_preloads.compartments.show",
  sourceFilesClientCorrespondencesManage: "source_files.client_correspondences.manage",
  sourceFilesCompartmentsManage: "source_files.compartments.manage",
  sourceFilesOrdersManage: "source_files.orders.manage",
  sourceFilesTrucksManage: "source_files.trucks.manage",
  systemDiagnosticsManage: "system.diagnostics.manage",
  systemSettingsEstimationWrite: "system.settings.estimation.write",
  systemSettingsDeploymentUpdateWrite: "system.settings.deployment_update.write",
  systemSettingsDispatchPeriodToggleWrite: "system.settings.dispatch_period_toggle.write",
  systemSettingsFleetSegmentHovercardWrite: "system.settings.fleet_segment_hovercard.write",
  systemSettingsHereRoutingWrite: "system.settings.here_routing.write",
  systemSettingsImportDefaultsWrite: "system.settings.import_defaults.write",
  systemSettingsImportSollioAmWrite: "system.settings.import_sollio_am.write",
  systemSettingsPriorityPreAnchorWrite: "system.settings.priority.pre_anchor.write",
  systemSettingsPriorityTimeWindowsWrite: "system.settings.priority.time_windows.write",
  systemSettingsRead: "system.settings.read",
  systemSettingsRouteAlternativesWrite: "system.settings.route_alternatives.write",
  systemSettingsFastOptimizationWrite: "system.settings.fast_optimization.write",
  systemSettingsSolverActivationWrite: "system.settings.solver.activation.write",
  systemSettingsSolverOrtoolsSeedWrite: "system.settings.solver.ortools_seed.write",
  systemSettingsSolverSameOdGroupingWrite: "system.settings.solver.same_od_grouping.write",
  systemSettingsSolverWorkTimeWrite: "system.settings.solver.work_time.write",
  systemSettingsSolverFixedTimesWrite: "system.settings.solver.fixed_times.write",
  systemSettingsSolverLowLoadThresholdWrite: "system.settings.solver.low_load_threshold.write",
  systemSettingsSolverGreedyLowLoadPenaltyWrite: "system.settings.solver.greedy_low_load_penalty.write",
  systemSettingsSolverCompartmentFillWrite: "system.settings.solver.compartment_fill.write",
  systemSettingsTrafficRoutingWrite: "system.settings.traffic_routing.write",
  technicalPlanningReset: "technical.planning.reset",
  technicalDispatchSnapshotDelete: "technical.dispatch_snapshot.delete",
  technicalRailwayRestart: "technical.railway.restart",
  technicalRouteCacheReset: "technical.route_cache.reset",
};

export const SYSTEM_CONFIG_WRITE_PERMISSION_KEYS = [
  ACCESS_PERMISSION_KEYS.systemSettingsEstimationWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsDispatchPeriodToggleWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsDeploymentUpdateWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsImportDefaultsWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsImportSollioAmWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsSolverActivationWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsSolverOrtoolsSeedWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsSolverWorkTimeWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsSolverFixedTimesWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsPriorityPreAnchorWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsPriorityTimeWindowsWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsSolverSameOdGroupingWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsSolverLowLoadThresholdWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsSolverGreedyLowLoadPenaltyWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsSolverCompartmentFillWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsHereRoutingWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsTrafficRoutingWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsFleetSegmentHovercardWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsRouteAlternativesWrite,
  ACCESS_PERMISSION_KEYS.systemSettingsFastOptimizationWrite,
];

export const DISPATCH_PAGE_PERMISSION_KEYS = [
  ACCESS_PERMISSION_KEYS.dispatchRead,
  ACCESS_PERMISSION_KEYS.dispatchDayClose,
  ACCESS_PERMISSION_KEYS.dispatchDayInvalidate,
  ACCESS_PERMISSION_KEYS.dispatchDayPublishPortal,
  ACCESS_PERMISSION_KEYS.dispatchDayReopen,
  ACCESS_PERMISSION_KEYS.dispatchDayResetRevalidation,
  ACCESS_PERMISSION_KEYS.dispatchAssignmentWrite,
  ACCESS_PERMISSION_KEYS.dispatchDeliveryFreeze,
  ACCESS_PERMISSION_KEYS.dispatchPullForwardManage,
  ACCESS_PERMISSION_KEYS.dispatchRun,
  ACCESS_PERMISSION_KEYS.dispatchSnapshotRestore,
  ACCESS_PERMISSION_KEYS.dispatchSnapshotWrite,
  ACCESS_PERMISSION_KEYS.dispatchSourceChangesWrite,
];

export const BILLING_PAGE_PERMISSION_KEYS = [
  ACCESS_PERMISSION_KEYS.billingRead,
  ACCESS_PERMISSION_KEYS.billingDraftsManage,
  ACCESS_PERMISSION_KEYS.billingSend,
  ACCESS_PERMISSION_KEYS.billingVoid,
  ACCESS_PERMISSION_KEYS.billingSettingsManage,
];

export const BILLING_WORKSPACE_PERMISSION_KEYS = [
  ACCESS_PERMISSION_KEYS.consolidationHoursManage,
  ACCESS_PERMISSION_KEYS.consolidationGeotabRead,
  ACCESS_PERMISSION_KEYS.consolidationSummaryRead,
  ACCESS_PERMISSION_KEYS.consolidationHoursRead,
  ...BILLING_PAGE_PERMISSION_KEYS,
  ACCESS_PERMISSION_KEYS.consolidationRead,
  ACCESS_PERMISSION_KEYS.consolidationWrite,
  ACCESS_PERMISSION_KEYS.consolidationValidate,
  ACCESS_PERMISSION_KEYS.consolidationReopen,
];

export const ACCESS_ROLE_KEYS = {
  admin: "admin",
  billing: "billing",
  driver: "driver",
  operationsManager: "operations_manager",
  user: "user",
};

export const IMPORT_UPLOAD_PERMISSION_BY_FIELD = {
  client_correspondences: ACCESS_PERMISSION_KEYS.importsClientCorrespondencesUpload,
  compartments: ACCESS_PERMISSION_KEYS.importsCompartmentsUpload,
  employees: ACCESS_PERMISSION_KEYS.importsEmployeesUpload,
  orders: ACCESS_PERMISSION_KEYS.importsOrdersUpload,
  products: ACCESS_PERMISSION_KEYS.importsProductsUpload,
  trucks: ACCESS_PERMISSION_KEYS.importsTrucksUpload,
};

export const SOURCE_FILE_UPLOAD_PERMISSION_BY_FIELD = {
  client_correspondences: ACCESS_PERMISSION_KEYS.sourceFilesClientCorrespondencesManage,
  compartments: ACCESS_PERMISSION_KEYS.sourceFilesCompartmentsManage,
  employees: ACCESS_PERMISSION_KEYS.importsEmployeesUpload,
  orders: ACCESS_PERMISSION_KEYS.sourceFilesOrdersManage,
  products: ACCESS_PERMISSION_KEYS.importsProductsUpload,
  trucks: ACCESS_PERMISSION_KEYS.sourceFilesTrucksManage,
};

export const DATA_MANAGER_EXPORT_PERMISSION_BY_KIND = {
  orders: ACCESS_PERMISSION_KEYS.dataManagerOrdersExport,
  trucks: ACCESS_PERMISSION_KEYS.dataManagerTrucksExport,
  compartments: ACCESS_PERMISSION_KEYS.dataManagerCompartmentsExport,
  client_correspondences: ACCESS_PERMISSION_KEYS.dataManagerClientCorrespondencesExport,
  employees: ACCESS_PERMISSION_KEYS.dataManagerEmployeesExport,
  products: ACCESS_PERMISSION_KEYS.dataManagerProductsExport,
  dispatch_saves: ACCESS_PERMISSION_KEYS.dataManagerDispatchSavesExport,
};

export const DATA_MANAGER_EXPORT_PERMISSION_KEYS = Object.values(DATA_MANAGER_EXPORT_PERMISSION_BY_KIND);

export const IMPORT_PAGE_PERMISSION_KEYS = [
  ...new Set([
    ...Object.values(IMPORT_UPLOAD_PERMISSION_BY_FIELD),
    ...Object.values(SOURCE_FILE_UPLOAD_PERMISSION_BY_FIELD),
    ACCESS_PERMISSION_KEYS.importsReplaceAll,
		ACCESS_PERMISSION_KEYS.dataManagerClientCorrespondencesWrite,
  ]),
];

function normalizeText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function normalizePermissionKey(value) {
  return normalizeText(value).toLowerCase();
}

export function normalizePermissionList(value) {
  if (!Array.isArray(value)) {
    return [];
  }

  return [...new Set(value.map((item) => normalizePermissionKey(item)).filter(Boolean))];
}

function normalizeOptionalBoolean(value) {
  return typeof value === "boolean" ? value : null;
}

export function buildAccessState(payload = null) {
  const permissions = normalizePermissionList(payload?.permissions);

  return {
    activeRole: normalizePermissionKey(payload?.active_role),
    accountType: normalizePermissionKey(payload?.account_type) || null,
    dispatcherWorkspaceAccess: normalizeOptionalBoolean(payload?.dispatcher_workspace_access),
    driverPortalAccess: normalizeOptionalBoolean(payload?.driver_portal_access),
    permissions,
    permissionSet: new Set(permissions),
    source: normalizePermissionKey(payload?.source),
    userId: normalizeText(payload?.user_id),
  };
}

export const EMPTY_ACCESS_STATE = buildAccessState();

export function hasPermission(accessState, permissionKey) {
  const normalizedPermissionKey = normalizePermissionKey(permissionKey);
  if (!normalizedPermissionKey) {
    return false;
  }

  if (accessState?.permissionSet instanceof Set) {
    return accessState.permissionSet.has(normalizedPermissionKey);
  }

  return normalizePermissionList(accessState?.permissions).includes(normalizedPermissionKey);
}

export function canShowReportCompartments(accessState, reportKey) {
  const permission = {
    truck_sheets: ACCESS_PERMISSION_KEYS.reportsTruckSheetsCompartmentsShow,
    truck_preloads: ACCESS_PERMISSION_KEYS.reportsTruckPreloadsCompartmentsShow,
  }[reportKey];
  return hasPermission(accessState, permission);
}

export function hasAnyPermission(accessState, permissionKeys) {
  if (!Array.isArray(permissionKeys) || permissionKeys.length === 0) {
    return false;
  }

  return permissionKeys.some((permissionKey) => hasPermission(accessState, permissionKey));
}

export function canAccessImportPage(accessState) {
  return hasAnyPermission(accessState, IMPORT_PAGE_PERMISSION_KEYS);
}

export function canReadSystemSettings(accessState) {
  return hasAnyPermission(accessState, [
    ACCESS_PERMISSION_KEYS.systemSettingsRead,
    ...SYSTEM_CONFIG_WRITE_PERMISSION_KEYS,
  ]);
}

export function canManageSensitiveSystemSettings(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.systemSettingsTrafficRoutingWrite);
}

export function canManageSystemDiagnostics(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.systemDiagnosticsManage);
}

export function canAccessSystemConfigPage(accessState) {
  return canReadSystemSettings(accessState)
    || canManageSystemDiagnostics(accessState);
}

export function canManageAccessUsers(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.accessUsersWrite);
}

export function canManageDriverAccounts(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.driverAccountsManage);
}

export function canAccessDriverPortal(accessState) {
  if (typeof accessState?.driverPortalAccess === "boolean") {
    return accessState.driverPortalAccess;
  }

  if (accessState?.accountType === "driver_portal") {
    return true;
  }

  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.driverPortalAccess);
}

export function canReadAccessCatalog(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.accessRolesWrite);
}

export function canReadAccessAudit(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.auditAccessRead);
}

export function canAccessAccessManagement(accessState) {
  return canManageAccessUsers(accessState) || canReadAccessCatalog(accessState) || canReadAccessAudit(accessState);
}

export function canAccessAdminPage(accessState) {
  return canAccessAccessManagement(accessState);
}

export function canManageAutomations(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.automationsManage);
}

export function canAccessBillingPage(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.billingRead);
}

export function isBillingWorkspaceOnly(accessState) {
  if (hasActiveRole(accessState, ACCESS_ROLE_KEYS.billing)) {
    return true;
  }
  const activeRole = normalizePermissionKey(accessState?.activeRole);
  if (Object.values(ACCESS_ROLE_KEYS).includes(activeRole)) {
    return false;
  }
  const permissions = normalizePermissionList(accessState?.permissions);
  const allowedPermissions = new Set(BILLING_WORKSPACE_PERMISSION_KEYS);
  return permissions.length > 0 && permissions.every((permissionKey) => allowedPermissions.has(permissionKey));
}

export function canAccessConsolidationPage(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.consolidationRead);
}

export function canAccessGeneralWorkspacePage(accessState) {
  return !isBillingWorkspaceOnly(accessState);
}

export function canAccessDataManagerPage(accessState) {
  return canAccessGeneralWorkspacePage(accessState);
}

export function resolveBillingWorkspaceEntryPath(accessState) {
  if (!isBillingWorkspaceOnly(accessState)) {
    return "";
  }
  if (canAccessBillingPage(accessState)) {
    return "/billing";
  }
  if (canAccessConsolidationPage(accessState)) {
    return "/consolidation";
  }
  return "";
}

export function canAccessBillingWorkspacePath(accessState, pathname) {
  if (!isBillingWorkspaceOnly(accessState)) {
    return true;
  }
  const normalizedPathname = normalizeText(pathname).replace(/\/+$/, "") || "/";
  if (normalizedPathname === "/billing") {
    return canAccessBillingPage(accessState);
  }
  if (normalizedPathname === "/consolidation") {
    return canAccessConsolidationPage(accessState);
  }
  if (normalizedPathname === "/geotab") {
    return canAccessGeotabPage(accessState);
  }
  if (normalizedPathname === "/accueil") {
    return !resolveBillingWorkspaceEntryPath(accessState);
  }
  return false;
}

export function canAccessDispatchPage(accessState) {
  return hasAnyPermission(accessState, DISPATCH_PAGE_PERMISSION_KEYS);
}

export function canAccessGeotabPage(accessState) {
  return hasAnyPermission(accessState, [
    ACCESS_PERMISSION_KEYS.geotabRead,
    ACCESS_PERMISSION_KEYS.geotabLiveRead,
    ACCESS_PERMISSION_KEYS.geotabCalibrationRead,
    ACCESS_PERMISSION_KEYS.geotabDevicesRead,
  ]);
}

export function canManageDispatcherFreeze(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dispatchDeliveryFreeze);
}

export function canPublishDriverPortal(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dispatchDayPublishPortal);
}

export function canDeleteDeliveredOrders(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dataManagerOrdersDeleteCompleted);
}

export function canClearDeliveredOrders(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dataManagerOrdersClearDelivered);
}

export function canWriteOrderActualTonnage(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dataManagerOrdersActualTonnageWrite);
}

export function canWriteOrderDeliveryDriver(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dataManagerOrdersDeliveryDriverWrite);
}

export function canMarkOrdersDelivered(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dataManagerOrdersMarkDelivered);
}

export function canEditOrders(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dataManagerOrdersWrite);
}

export function canManageDataManagerImports(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dataManagerImportsManage);
}

export function canExportDataManagerTable(accessState, kind) {
  return hasPermission(accessState, DATA_MANAGER_EXPORT_PERMISSION_BY_KIND[kind]);
}

export function canAccessDataManagerAdminTransfer(accessState) {
  return canManageDataManagerImports(accessState)
    || hasAnyPermission(accessState, DATA_MANAGER_EXPORT_PERMISSION_KEYS);
}

export function canBulkDeleteOrders(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.dataManagerOrdersBulkDelete);
}

export function hasActiveRole(accessState, roleKey) {
  const normalizedRoleKey = normalizePermissionKey(roleKey);
  if (!normalizedRoleKey) {
    return false;
  }

  return normalizePermissionKey(accessState?.activeRole) === normalizedRoleKey;
}

export function isAdminRole(accessState) {
  return hasActiveRole(accessState, ACCESS_ROLE_KEYS.admin);
}

export function canAccessLocalToolsPage(accessState, hostname = globalThis.location?.hostname) {
  return isAdminRole(accessState) && ["localhost", "127.0.0.1", "[::1]", "::1"].includes(hostname);
}

export function canManageRouteAlternatives(accessState) {
  return isAdminRole(accessState)
    || hasPermission(accessState, ACCESS_PERMISSION_KEYS.systemSettingsRouteAlternativesWrite);
}

export function canUseFastOptimizationMode(accessState) {
  return isAdminRole(accessState)
    || hasPermission(accessState, ACCESS_PERMISSION_KEYS.systemSettingsFastOptimizationWrite);
}

export function canManageImports(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.importsReplaceAll);
}

export function canSendReportsEmail(accessState) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.reportsEmailSend);
}

export function canManageSourceField(accessState, field) {
  const permissionKey = SOURCE_FILE_UPLOAD_PERMISSION_BY_FIELD[field];
  return hasPermission(accessState, permissionKey);
}

export function canManageAnySourceFile(accessState) {
  return Object.keys(SOURCE_FILE_UPLOAD_PERMISSION_BY_FIELD).some((field) => canManageSourceField(accessState, field));
}

export function canUseOrderImportGuardBypass(accessState, { isDev = false } = {}) {
  return hasPermission(accessState, ACCESS_PERMISSION_KEYS.importsOrdersGuardBypass);
}

function resolveNavItemChildren(item) {
  const childCandidates = [item?.sub_items, item?.subItems, item?.children];
  const resolvedChildren = childCandidates.find((candidate) => Array.isArray(candidate));
  return Array.isArray(resolvedChildren)
    ? resolvedChildren.filter((candidate) => candidate && typeof candidate === "object")
    : [];
}

const NAV_ITEM_ACCESS_CHECK_BY_KEY = {
  affectation: canAccessDispatchPage,
  geotab: canAccessGeotabPage,
  admin: canAccessAdminPage,
  "local-tools": canAccessLocalToolsPage,
  automations: canManageAutomations,
  billing: canAccessBillingPage,
  consolidation: canAccessConsolidationPage,
  "data-manager": canAccessDataManagerPage,
  "diagnostic-suspended": canAccessDispatchPage,
  portal: canAccessDriverPortal,
  "driver-accounts": canManageDriverAccounts,
  import: canAccessImportPage,
  results: canAccessDispatchPage,
  "system-config": canAccessSystemConfigPage,
  "dispatch-captures": canManageSystemDiagnostics,
};

export function isNavItemVisibleForAccess(item, accessState) {
  if (!item || typeof item !== "object") {
    return false;
  }

  const itemKey = normalizeText(item.key).toLowerCase();
  const accessCheck = NAV_ITEM_ACCESS_CHECK_BY_KEY[itemKey];
  if (typeof accessCheck === "function" && !accessCheck(accessState)) {
    return false;
  }

  const childItems = resolveNavItemChildren(item);
  if (childItems.length === 0) {
    return true;
  }

  return childItems.some((childItem) => isNavItemVisibleForAccess(childItem, accessState));
}

function filterNavItemsByAccess(items, accessState) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.reduce((nextItems, item) => {
    if (!isNavItemVisibleForAccess(item, accessState)) {
      return nextItems;
    }

    const childItems = resolveNavItemChildren(item);
    const nextChildItems = filterNavItemsByAccess(childItems, accessState);

    nextItems.push({
      ...item,
      ...(childItems.length > 0 ? { sub_items: nextChildItems } : {}),
    });
    return nextItems;
  }, []);
}

export function filterNavSectionsByAccess(navSections, accessState) {
  if (!Array.isArray(navSections)) {
    return [];
  }

  return navSections.reduce((nextSections, section) => {
    const nextItems = filterNavItemsByAccess(section?.items, accessState);
    if (!nextItems.length) {
      return nextSections;
    }

    nextSections.push({
      ...section,
      items: nextItems,
    });
    return nextSections;
  }, []);
}
